import React,{Component,Fragment} from 'react';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import Viewer, { Worker } from "@phuocng/react-pdf-viewer";
import Wrappercontainer from "../components/Wrappercontainer";
import {withRouter} from 'react-router-dom';
import {getTestFile,automatedSingleFileUpload,listAttachments,viewFile,removeAttachment} from "../actions";
import Listofattachments from "../components/Listofattachments";
import {connect} from 'react-redux';
import FileBase64 from "../components/FileBase64";
import renderIf from 'render-if';
import {Grid, Backdrop, CircularProgress, Snackbar} from "@material-ui/core";
import {Alert, AlertTitle} from "@material-ui/lab";
import AppBarTop from "../components/AppBarTop";
let flag = true;
class ClinicView extends Component{
  state={
    // Snack Bar states
    showBackDrop:false,
    showSnackbar:false,
    snackbarMessage:"",
    snackbartype:"",
    snackbarSubMessage:"",
    link:'',
    isUploading:false,
    attachments:[],
    counter:0
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if(this.props.auth.data){ this.props.listAttachments(this.props.auth.data.agency); }
  }

  getFilesAttachments(files) {
    flag=true;
    this.setState({isUploading:true,backdropmsg:'Uploading Document'});
    if(this.props.auth.data){

      files.map(file=>{
        this.props.automatedSingleFileUpload(file,this.props.auth.data);
      })
    }
  }

  handleRowClick(attachment){
    this.props.viewFile(attachment.hashValue,attachment.filename);
  }

  handleRemoveRowClick(attachment){
    flag=true;
    this.setState({isUploading:true,backdropmsg:'Removing Document'});
    this.props.removeAttachment(attachment.hashValue,this.props.auth.data.agency);
  }

  render() {
    console.log(this.state.counter)
    return(
      <Fragment>
        <AppBarTop handleLogout={()=>this.props.history.push("/")}/>
        <Wrappercontainer large>
          <Grid container spacing={3}>
            <Grid item xs={7} >
              {renderIf(this.state.link.length>0)(<Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.js">
                <div style={{height: "750px"}}>
                  <Viewer fileUrl={this.state.link}/>
                </div>
              </Worker>)}
            </Grid>
            <Grid item xs={5} >
              <FileBase64
                multiple={true}
                title="click here to add PDF"
                onDone={this.getFilesAttachments.bind(this)}
              />
              <Listofattachments handleRemoveRowClick={attachment=>this.handleRemoveRowClick(attachment)} tblattachments={this.state.attachments} handleRowClick={attachment=>this.handleRowClick(attachment)}/>
            </Grid>
          </Grid>
        </Wrappercontainer>
        <Backdrop style={{color:'#fff',zIndex:10000}} open={this.state.isUploading}>
          <Alert  severity={'info'}>
            <div style={{display:'flex',flexDirection:'row'}}>
              <AlertTitle>Please wait ...</AlertTitle>
              <CircularProgress style={{marginLeft:75}} size={20} color={'black'}/>
            </div>
            <strong>{this.state.backdropmsg}</strong>
          </Alert>
        </Backdrop>

        <Snackbar anchorOrigin={{vertical: 'bottom',horizontal: 'right'}}
                  open={this.state.showSnackbar} autoHideDuration={4000}
                  onClose={()=>this.setState({showSnackbar:false})}>
          <Alert onClose={()=>this.setState({showSnackbar:false})} severity={this.state.snackbartype}>
            <AlertTitle>{this.state.snackbarMessage}</AlertTitle>
            <strong>{this.state.snackbarSubMessage}</strong>
          </Alert>
        </Snackbar>
      </Fragment>
    )
  }
  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.files){
      let counter = this.state.counter;
      this.setState({counter:counter+1});
    }

    if(nextProps.viewer){
      this.setState({link:nextProps.viewer});
    }


    if(nextProps.attachments){
      this.setState({attachments:nextProps.attachments,isUploading:false,snackbartype:"success",snackbarMessage:"Done."});
      flag = false
    }
  }
}

const mapStateToProps = (data) => {
  return data;
}

export default connect(mapStateToProps,{getTestFile,automatedSingleFileUpload,listAttachments,viewFile,removeAttachment})(withRouter(ClinicView));
